import { Navigate, useNavigate } from 'react-router';
import { useObjects } from '../data/hooks';
import { Button, EmptyState, Skeleton } from '../ui';

/**
 * There is no dashboard yet, so the start page is the first object's list. When an
 * installation has no objects at all, the honest landing page is the one that says
 * so and links to the admin.
 */
export function HomeRedirect() {
  const objects = useObjects();
  const navigate = useNavigate();

  if (objects.isPending) {
    return (
      <div className="space-y-3 py-8" aria-busy="true">
        <Skeleton className="h-8 w-40" />
        <Skeleton shape="block" />
      </div>
    );
  }

  const first = objects.data?.[0];
  if (first === undefined) {
    return (
      <EmptyState
        icon="settings"
        title="No objects"
        description="Create the first object to start capturing data."
        action={
          <Button variant="primary" onClick={() => void navigate('/settings/objects')}>
            Create object…
          </Button>
        }
      />
    );
  }

  return <Navigate to={`/objects/${first.id}`} replace />;
}
